import { all } from 'redux-saga/effects';

import downloadDocuments from './downloadDocuments';
import { uploadDocumentSaga } from './uploadDocument';

export default function* () {
    yield all([downloadDocuments(), uploadDocumentSaga()]);
}
